module.exports = __webpack_public_path__ + "static/media/creambow-logo.3d432359.png";